import getScriptBaseUrl from 'owa-session-store/lib/actions/getScriptBaseUrl';
import { getSessionId } from 'owa-analytics/lib/LazyAnalytics';

export default function() {
    return {
        UserAgent: window.navigator.userAgent,
        ScriptSource: getScriptBaseUrl(),
        SessionId: getSessionId(),
        ClientId: window.bootstrapDiagnostics.clientId,
        ClientServer: window.bootstrapDiagnostics.server,
        BEServer: window.genericDiagnostics && window.genericDiagnostics.be,
    };
}
